import { AsyncAjaxPost } from '../components/Utilities/AsyncAjaxService';

const VagaroAPIEnum = {
    getMerchantRoot: "merchants/",
    addTrackingEvent: "tracking/save"
};

export const getOrCreateAnonymousGuid = () => {
    let guid = localStorage.getItem("tracking_guid");
    if (!guid) {
        guid = crypto.randomUUID();
        localStorage.setItem("tracking_guid", guid);
    }
    return guid;
};

export const AddTrackingEvent = async (EventType: Number, ParentID: string, Url: string, Title: string, Referrer: string, MerchantID: string, UserID: string, Callback?: Function) => {
    const url = VagaroAPIEnum.getMerchantRoot + VagaroAPIEnum.addTrackingEvent;
    // Ensure the GUID is a valid string
    const content = {
        guid: getOrCreateAnonymousGuid(),
        mode: EventType,
        parentId: ParentID,
        url: Url,
        title: Title,
        referrer: Referrer,
        userAgent: navigator.userAgent,
    };
    await AsyncAjaxPost(url, JSON.stringify(content), "", Callback, Callback, MerchantID, UserID);
}

// Custom Hook for Track Event API Call 
export const useTrackingEvent = () => {
    const TrackEvent = async (
        ParentID: string,
        merchantId: string,
        userId: string,
        eventType: number,
        url: string,
        title: string,
        callback?: () => void
    ) => {
        try {
            await AddTrackingEvent(
                eventType,
                ParentID,
                url,
                title,
                window.location.href,
                merchantId,
                userId,
                callback
            );
        } catch (error) {
            console.error('Error in addTrackingEvent:', error);
        }
    };

    return [TrackEvent];
};
